import { CompareTypeAdapter } from './compare-type-adapter.model';
import { maturityCompareAdapter } from './maturity.compare-adapter';
import { temperatureCompareAdapter } from './temperature.compare-adapter';
import { shmCompareAdapter } from './shm.compare-adapter';

export * from './compare-type-adapter.model';

/** Keyed by Measurement.measurementType. Absent key ⇒ "not supported in compare yet". */
export const COMPARE_TYPE_REGISTRY: Record<string, CompareTypeAdapter> = {
  MaturityMeasurement: maturityCompareAdapter,
  TemperatureMeasurement: temperatureCompareAdapter,
  StructuralHealthMeasurement: shmCompareAdapter,
};
